import React, { useState } from 'react';
import FolderPickerModal from './FolderPickerModal';

const FolderDetailModal = ({
  folder,
  path,
  parentOptions,
  editTitle,
  editDescription,
  editParentId,
  editReleased,
  editAllowedUsers,
  editIsCollege,
  user,
  error,
  users = [],
  userGroups = [],
  onTitleChange,
  onDescriptionChange,
  onParentChange,
  onReleasedChange,
  onAllowedGroupsChange,
  onAllowedUsersChange,
  onTypeToggle,
  onSave,
  onDelete,
  onClose
}) => {
  const [showPicker, setShowPicker] = useState(false);

  if (!folder) return null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-card" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Folder details</h3>
            <button className="secondary" type="button" onClick={onClose}>Close</button>
          </div>

          <div className="section">
            <div className="breadcrumb">
              <button className="link-button" type="button" onClick={onClose}>
                All folders
              </button>
              {path.map((item) => (
                <span key={item._id} className="breadcrumb-item">
                  <span className="breadcrumb-separator">/</span>
                  <span>{item.title}</span>
                </span>
              ))}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label style={{ margin: 0 }}><strong>Folder type:</strong></label>
              {['super_user', 'college_admin', 'teacher'].includes(user?.role) ? (
                <button 
                  type="button" 
                  className="secondary small" 
                  onClick={onTypeToggle}
                  style={{ padding: '4px 10px', fontSize: '0.8rem', background: editIsCollege ? 'rgba(79, 70, 229, 0.1)' : 'var(--bg-main)', color: editIsCollege ? 'var(--primary)' : 'var(--text-muted)', border: `1px solid ${editIsCollege ? 'var(--primary)' : 'var(--border-light)'}` }}
                >
                  <i className={`fas fa-${editIsCollege ? 'university' : 'folder'}`} style={{ marginRight: '6px' }} />
                  {editIsCollege ? 'College Folder' : 'General Folder'}
                </button>
              ) : (
                <span>{editIsCollege ? 'College' : 'General'}</span>
              )}
            </div>
            
            {folder.college && (
              <p><strong>College:</strong> {folder.college}</p>
            )}
          </div>

          <div className="section" style={{ display: 'grid', gap: '12px' }}>
            <label>Folder title</label>
            <input value={editTitle} onChange={onTitleChange} />

            <label>Description (optional)</label>
            <textarea 
              value={editDescription} 
              onChange={onDescriptionChange} 
              placeholder="What is this folder for?"
              rows={3}
              style={{ minHeight: '80px', borderRadius: 'var(--radius-md)' }}
            />

            <label>Move under parent</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button type="button" className="secondary" onClick={() => setShowPicker(true)} style={{ flex: 1, textAlign: 'left', background: '#f8fafc', padding: '8px 12px', border: '1px solid #cbd5e1', borderRadius: '6px' }}>
                {editParentId ? parentOptions.find(f => f._id === editParentId)?.title || 'Root folder' : 'Root folder'}
              </button>
              {editParentId && (
                <button type="button" className="icon-button danger" onClick={() => onParentChange({ target: { value: '' } })} title="Clear selection">
                  <i className="fas fa-times" />
                </button>
              )}
            </div>

            <label className="released-toggle" style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', userSelect: 'none' }}>
              <input
                type="checkbox"
                checked={!!editReleased}
                onChange={onReleasedChange}
                style={{ width: '18px', minWidth: '18px', height: '18px', accentColor: '#16a34a', cursor: 'pointer' }}
              />
              <span>
                <strong style={{ color: editReleased ? '#16a34a' : '#94a3b8' }}>
                  {editReleased ? '✓ Released' : 'Not released'}
                </strong>
                <span style={{ display: 'block', fontSize: '0.8rem', color: '#64748b' }}>
                  {editReleased ? 'Visible on the Browse page' : 'Hidden from the Browse page'}
                </span>
              </span>
            </label>
          </div>

          {error && (
            <div className="error-message" style={{ margin: '0 0 4px' }}>{error}</div>
          )}

          <div className="modal-actions">
            <button type="button" onClick={onSave}>Save</button>
            <button type="button" className="secondary" onClick={onDelete}>Delete folder</button>
          </div>
        </div>
      </div>
      {showPicker && (
        <FolderPickerModal
          title="Select Parent Folder"
          folders={parentOptions}
          allowRoot={true}
          onSelect={(id) => { onParentChange({ target: { value: id } }); setShowPicker(false); }}
          onClose={() => setShowPicker(false)}
        />
      )}
    </>
  );
};

export default FolderDetailModal;
